// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
export var red = (_obj = {}, _define_property(_obj, 50, '#FFEAE5'), _define_property(_obj, 100, '#FED5CD'), _define_property(_obj, 200, '#FEAB9A'), _define_property(_obj, 300, '#FB826A'), _define_property(_obj, 400, '#F55C3D'), _define_property(_obj, 500, '#F33712'), _define_property(_obj, 600, '#CB2B0B'), _define_property(_obj, 700, '#A41F04'), _define_property(_obj, 800, '#6D1503'), _define_property(_obj, 900, '#460D02'), _define_property(_obj, 950, '#280801'), _obj);

//# sourceMappingURL=red.js.map